import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../supabaseClient';
import { navigateToResumedWorkspace } from '../../lib/resolveMostRecentWorkspace';

const ResetPassword = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (password.length < 6) {
      setError('Password must be at least 6 characters long');
      return;
    }

    setLoading(true);
    try {
      const { error } = await supabase.auth.updateUser({ password });
      if (error) throw error;

      const { data: { user } } = await supabase.auth.getUser();
      if (user) {
        await navigateToResumedWorkspace(navigate, user.id);
      } else {
        navigate('/workspace');
      }
    } catch (error) {
      setError(error.message || 'An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-neutral-50 flex flex-col justify-center items-center p-4 sm:p-6 font-['Inter', sans-serif]">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-xl shadow-lg p-4 sm:p-8 border-2 border-neutral-900">
          <h2 className="text-2xl sm:text-3xl font-bold text-center mb-4 sm:mb-6 text-neutral-900">
            Reset Password
          </h2>
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="password" className="block text-sm font-medium text-neutral-900">
                New Password
              </label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="mt-1 block w-full px-4 py-2 rounded-xl border-2 border-neutral-900 focus:border-cranberry-700 focus:ring-1 focus:ring-cranberry-700 outline-none"
              />
            </div>
            <div>
              <label htmlFor="confirmPassword" className="block text-sm font-medium text-neutral-900">
                Confirm New Password
              </label>
              <input
                type="password"
                id="confirmPassword"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                className="mt-1 block w-full px-4 py-2 rounded-xl border-2 border-neutral-900 focus:border-cranberry-700 focus:ring-1 focus:ring-cranberry-700 outline-none"
              />
            </div>
            {error && (
              <div className="text-sm text-red-600 bg-red-50 border-l-4 border-red-600 p-4 rounded-r-xl">
                {error}
              </div>
            )}
            <button
              type="submit"
              className="w-full flex justify-center py-2 px-6 rounded-xl text-white bg-cranberry-700 hover:bg-cranberry-600 transition-colors duration-300 font-medium border-2 border-neutral-900"
              disabled={loading}
            >
              {loading ? 'Processing...' : 'Reset Password'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
